import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS, (state, action) => {
      const { response = { entities: {} } } = action;
      const { entities = { companies: {} } } = response;
      const { companies } = entities;
      if (companies) {
        return {
          ...state,
          ...companies,
        };
      }
    })
    .addCase(actionTypes.ADD_COMPANY, (state, action) => {
      if (action.response && action.response.single) {
        state[action.response.single.id] = action.response.single;
      }
      return state;
    })
    .addCase(actionTypes.TRASH_COMPANY, (state, action) => {
      if (action.response && action.response.id) {
        const { [action.response.id]: _deleted, ...rest } = state;
        return rest;
      }
      return state;
    })
    .addCase(actionTypes.LOAD_COMPANIES, (state, action) => {
      if (action.response && Array.isArray(action.response)) {
        action.response.forEach((company) => {
          state[company.id] = company;
        });
      }
      return state;
    })
    .addCase(actionTypes.LOAD_COMPANY, (state, action) => {
      if (action.response && !!action?.company_id) {
        if (action?.response?.single) {
          state[action.company_id] = action.response.single;
        }
      }
      return state;
    })
    .addCase(actionTypes.ANGULAR_INIT, (state, action) => {
      if (action.response && action.response.companies && Array.isArray(action.response.companies)) {
        action.response.companies.forEach((company) => {
          state[company.id] = company;
        });
      }
      return state;
    })
    .addMatcher(
      (action) =>
        [
          actionTypes.EDIT_COMPANY_SUCCESS,
          actionTypes.ARCHIVE_COMPANY_SUCCESS,
          actionTypes.MOVE_COMPANY_TO_TRASH_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        if (action.response && action.response.single) {
          state[action.response.single.id] = action.response.single;
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS, actionTypes.SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS].includes(
          action.type
        ),
      (state, action) => {
        const { response = { entities: {} } } = action;
        const { entities = { companies: {} } } = response;
        const { companies } = entities;
        if (companies) {
          return {
            ...state,
            ...companies,
          };
        }
      }
    )
    .addMatcher(
      (action) => [actionTypes.LOAD_COMPANY, actionTypes.EDIT_COMPANY].includes(action.type),
      (state, action) => {
        if (action.response && action.response.id) {
          state[action.response.id] = action.response;
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [
          actionTypes.ADD_COMPANY_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.EDIT_COMPANY_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.COMPANY_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.COMPANY_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.MOVE_COMPANY_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
          actionTypes.RESTORE_COMPANY_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        if (action?.response?.entities?.companies) {
          state = { ...state, ...action?.response?.entities?.companies };
        }
        return state;
      }
    );
});

export default reducer;
